export function $loadMathjax () {
  if (window.MathJax) {
    return true
  }
  let script = document.createElement('script')
  script.setAttribute('data-name', 'mathjax-latex')
  script.src = process.env.VUE_APP_CDN_MATHJAX_PATH + '?config=TeX-AMS_HTML'
  document.body.appendChild(script)
  script.onload = () => {
    let scriptConfig = document.createElement('script')
    scriptConfig.innerHTML = 'MathJax.Hub.Config({ jax: ["input/TeX","output/HTML-CSS"], tex2jax: {inlineMath: [["$","$"],["\\\\\\\\(","\\\\\\\\)"]]} });'
    document.body.appendChild(scriptConfig)
  }
}

export function $MathJaxHub (id) {
  if (window.MathJax && id) {
    window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, id])
  }
}

export function selectionQuestionValue (letters) {
  let powValues = []
  for (var pi = 0; pi < letters.length; pi++) {
    powValues.push(Math.pow(2, pi))
  }
  return powValues
}
export function getLettersValueMap (letters, powValues) {
  let map = {}
  for (var i = 0; i < letters.length; i++) {
    map[letters[i]] = powValues[i]
  }
  return powValues
}
export const LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
export const powValues = selectionQuestionValue(LETTERS)
export const LETTERS_VALUE_MAP = getLettersValueMap(LETTERS, powValues)
export function convertBinary (binary) {
  let result = ''
  binary = parseInt(binary, 10)
  for (let i = 0; i < powValues.length; i++) {
    const andValue = powValues[i]
    if (binary & andValue) {
      result += LETTERS[i]
    }
  }
  return result
}
export function convertBinarys (binary) {
  let results = ''
  if (/\d+/g.test(binary)) {
    results = convertBinary(binary)
  } else if (binary.includes('删除')) {
    results = '该题目错误，判断您的答案正确'
  } else {
    results = binary
  }
  return results
}
